import { useParams, Navigate, useSearchParams } from 'react-router-dom';

export const ReportViewRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const destination = `/app/reports/${id}${query ? `?${query}` : ''}`;

  return <Navigate to={destination} replace />;
};
